module.exports = __webpack_public_path__ + "static/img/K.839269f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ssxxg/K.png
// module id = O+y2
// module chunks = 0